import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/Core/services/user.service';

interface Location {
  id: string;
  label: string;
}

interface Device {
  serialnumber: string;
  id: string;
  location: Location;
  model: string;
  announcement: string;
  label: string;
  status: string;
}

@Component({
  selector: 'app-devices-display',
  templateUrl: './devices-display.component.html',
  styleUrls: ['./devices-display.component.css']
})
export class DevicesDisplayComponent implements OnInit {

  userID: string = '';
  devices: Device[]=[];
  status:string='';
  deviceDisplayToggle: boolean = true;
  
  constructor(private route: ActivatedRoute, private userService: UserService) {}
 
 
  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.userID = params.get('id') || '';
      this.fetchDevices();
    });
  }

  fetchDevices(): void {
    this.userService.getDevices(this.userID).subscribe((data) => {
      this.devices = data.map((device: { contact_lost: boolean; offline: boolean }) => ({
        ...device,
        status: this.getDeviceStatus(device.contact_lost),
      }));
      console.log(this.devices);
    });
  }

  getDeviceStatus(contactLost: boolean): string {
    return contactLost ? 'INACTIVE' : 'ACTIVE';
  }

  isNotSupportsDeviceStatus(device: Device): boolean {
    const unsupportedDeviceModels = ['smartfx'];
    return unsupportedDeviceModels.includes(device.model);
  }

  capitalizeFirstLetter(str: string | null | undefined): string {
    if (!str) {
      return '';
    }
    const capitalizedStr = str.charAt(0).toUpperCase() + str.slice(1);
    return capitalizedStr.replace(/_/g, ' ');
  }
  
}
